export enum OrgIntegrationService {
  acuity = 'acuity',
  apollo = 'apollo',
  calendly = 'calendly',
  chilipiper = 'chilipiper',
  clearbit = 'clearbit',
  gong = 'gong',
  hubspot = 'hubspot',
  hubspotMeetings = 'hubspot_meetings',
  intercom = 'intercom',
  outreach = 'outreach',
  salesforce = 'salesforce',
  salesloft = 'salesloft',
  sixsense = 'sixsense',
  slack = 'slack',
  teams = 'teams',
  zapier = 'zapier',
  zendesk = 'zendesk',
}

export enum UserIntegrationService {
  'google-calendar' = 'google-calendar',
  'microsoft-teams' = 'microsoft-teams',
  'outlook-calendar' = 'outlook-calendar',
  'zoom' = 'zoom',
}

export type IntegrationService = OrgIntegrationService | UserIntegrationService;

export interface OtherUserIntegration {
  service: UserIntegrationService;
}
